import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';
import ElementInViewHelper from '../../00_utilities/helpers/ElementInViewHelper';

class Header {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
        };
        this.boundWindowScrollListener = {};
        this.throttledWindowScrollListener = {};
    }

    init() {
        const prefersReducedMotion = AccessibilityHelper.prefersReducedMotion();
        if (this.elem.classList.contains('header--with-svg-animation') && !prefersReducedMotion) {
            // // get length of mask path once initially using this code and set this in scss for performance reasons
            // const svg = this.elem.querySelector('.svg-bg');
            // if (svg) {
            //     const svgMask = svg.querySelector('mask path');
            //     if (svgMask) {
            //         const pathLength = SvgViewHelper.getPathLength(svgMask);
            //         svg.style.setProperty('--animation-dashoffset', pathLength);
            //     }
            // }

            this.initIntersectionObserver();
        }
    }

    initIntersectionObserver() {
        const header = document.querySelector('.page-header');
        const { height: headerHeight } = header.getBoundingClientRect();

        const options = {
            rootMargin: `${headerHeight * -1}px 0px ${headerHeight * -1}px 0px`,
            threshold: [1],
        };
        const observer = new IntersectionObserver((entries, self) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio > 0.95) {
                    entry.target.classList.add('header--with-svg-animation-active');
                    self.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(this.elem);
    }

    windowScrollListener() {
        const percentageVisible = ElementInViewHelper.percentageVisible(this.elem);
        if (percentageVisible > 95) {
            this.elem.classList.add('header--with-svg-animation-active');
            window.removeEventListener('scroll', this.throttledWindowScrollListener);
        }
    }
}

export default Header;
